module.exports = __webpack_public_path__ + "media/images/global/icons/table-flower-29ae0ecd3625e0c065031ee53fa6f861.svg";